import React, {} from 'react';
import Datas from '../../../data/free-course/free-course1.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "../../styles/freeCourse1.js";
import { useTranslation } from 'react-i18next';

function FreeCourse1() {
    const { t } = useTranslation();

    return (
        <Styles>
            {/* Free Course */}
            <section className="free-course-area">
                <Container>
                    <Row>
                        <Col md="6">
                            <div className="course-text">
                                <h4>{t('home.how.title')}</h4>
                                <p>{t('home.how.subtitle')}</p>
                                <div className="course-text-extra">
                                    <p><strong>{t('home.how.steps.0.title')}:</strong> {t('home.how.steps.0.text')}</p>
                                    <p><strong>{t('home.how.steps.1.title')}:</strong> {t('home.how.steps.1.text')}</p>
                                    <p><strong>{t('home.how.steps.2.title')}:</strong> {t('home.how.steps.2.text')}</p>
                                    <p><strong>{t('home.how.steps.3.title')}:</strong> {t('home.how.steps.3.text')}</p>
                                    <p><strong>{t('home.how.steps.4.title')}:</strong> {t('home.how.steps.4.text')}</p>
                                    <p><strong>{t('home.how.steps.5.title')}:</strong> {t('home.how.steps.5.text')}</p>
                                </div>
                            </div>
                        </Col>
                        <Col md="6">
                            <img src={process.env.PUBLIC_URL + `/assets/images/${Datas.howWeWorkImage}`} alt="how_we_work" className="how_we_work_image_new" />
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    );
}

export default FreeCourse1